/**
 * Abode Studio — Seamless currency/location auto-detection via Shopify Markets.
 *
 * On first visit, fetches the visitor's detected country from Shopify's
 * browsing-context API and, if the detected country differs from the current
 * localization setting AND is available in the store's configured markets,
 * auto-submits the localization form to switch seamlessly.
 *
 * No popup or modal is shown. The preference is saved to localStorage so
 * return visitors keep their selection.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'abode_country_preference';

  // Current country ISO code set by Shopify's localization
  var currentCountry = document.documentElement.dataset.marketCountry;

  // If the user has already made a manual selection, respect it.
  if (localStorage.getItem(STORAGE_KEY)) return;

  // Fetch Shopify's geolocation suggestion
  fetch('/browsing_context_suggestions.json')
    .then(function (res) {
      if (!res.ok) throw new Error('Geolocation endpoint unavailable');
      return res.json();
    })
    .then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country;
      if (!detected || !detected.handle) return;

      var detectedCode = detected.handle.toUpperCase();

      // Already on the correct country — save preference and exit
      if (detectedCode === currentCountry) {
        localStorage.setItem(STORAGE_KEY, detectedCode);
        return;
      }

      // Check if the detected country is available in the store's markets
      // by looking for the matching option in the localization form
      var countryLink = document.querySelector(
        'localization-form a[data-value="' + detectedCode + '"]'
      );

      if (!countryLink) {
        // Detected country not available in store markets — stay on current
        localStorage.setItem(STORAGE_KEY, currentCountry);
        return;
      }

      // Save preference before redirect to prevent redirect loops
      localStorage.setItem(STORAGE_KEY, detectedCode);

      // Find the localization form and auto-submit with the detected country
      var form = document.querySelector('localization-form form');
      if (!form) return;

      var input = form.querySelector('input[name="country_code"]');
      if (!input) return;

      input.value = detectedCode;
      form.submit();
    })
    .catch(function () {
      // Silently fail — auto-detection is best-effort
    });
})();
